import { useEffect, useState } from "react";
import axios from "axios";
import { API, getAuthHeader } from "@/App";

let _cache = null;           // { at, promise }
const TTL = 5 * 60 * 1000;

export const refreshWorkingWindow = () => { _cache = null; };

// Label for the "Today + previous working day" scope (Sundays + Settings
// holidays skipped), e.g. "Today + Sat 10 Oct (Sunday skipped)".
export const useWorkingWindowLabel = () => {
  const [ww, setWw] = useState(null);
  useEffect(() => {
    if (!_cache || Date.now() - _cache.at > TTL) {
      _cache = { at: Date.now(), promise: axios.get(`${API}/settings/working-window`, { headers: getAuthHeader() })
        .then(r => r.data).catch(() => null) };
    }
    let alive = true;
    _cache.promise.then(d => { if (alive) setWw(d); });
    const onChange = () => {
      refreshWorkingWindow();
      _cache = { at: Date.now(), promise: axios.get(`${API}/settings/working-window`, { headers: getAuthHeader() })
        .then(r => r.data).catch(() => null) };
      _cache.promise.then(d => { if (alive) setWw(d); });
    };
    window.addEventListener("holidays-changed", onChange);
    return () => { alive = false; window.removeEventListener("holidays-changed", onChange); };
  }, []);
  return ww;
};
